import { render, staticRenderFns } from "./Alerts.vue?vue&type=template&id=3841877c&scoped=true"
import script from "./Alerts.vue?vue&type=script&lang=js"
export * from "./Alerts.vue?vue&type=script&lang=js"
import style0 from "./Alerts.vue?vue&type=style&index=0&id=3841877c&prod&lang=scss&scoped=true"
import style1 from "./Alerts.vue?vue&type=style&index=1&id=3841877c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3841877c",
  null
  
)

export default component.exports